import React, { useEffect, useState } from 'react'; //import React Component
import { NavLink } from 'react-router-dom';

export function Footer() {
    //(Function: ToTop) Go to top after switch page
    const topFunction = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };

    const [whatColor, setwhatColor] = useState({ color: "black" })
    let currentUser = localStorage.getItem("currentLoginUser")
    useEffect(() => {
        if (localStorage.getItem("currentLoginUser") !== null) {
            setwhatColor({ color: "#d4d4d4" })
        }
    }, [currentUser])

    return (
        <div>
            <footer id="footer_forbig">
                <div>
                    <img
                        draggable={false}
                        id="logo"
                        src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/logo.png?v=1678111937949"
                        alt="logo" />
                    <img
                        draggable={false}
                        id="logo"
                        src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/logoName.png?v=1678111941744"
                        alt="logo" />
                </div>
                <div style={{ marginTop: "50px" }}><strong>有任何更加紧急的问题？请联系我们的微信号: FOODiEra_Service</strong></div>
            </footer>

            <footer id="footer_forSmall">
                <div id="menu">
                    <ul className="breadcrumb">
                        <li><NavLink to={"/main"} onClick={topFunction}><span className="material-symbols-outlined">home</span></NavLink></li>
                        <li><NavLink to={"/profile"} onClick={topFunction}><span className="material-symbols-outlined">account_circle</span></NavLink></li>
                        <li><NavLink to={"/login"} onClick={topFunction} style={whatColor}>登录/注册</NavLink></li>
                    </ul>
                </div>
            </footer>
        </div>
    );
}